import React, { Component, Fragment } from "react";
import AUX from "../../hoc/Aux_";
import AuthService from "../Auth/AuthService";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import Autocomplete, {
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import { connect } from "react-redux";
import TextField from "@material-ui/core/TextField";
import paginationFactory from "react-bootstrap-table2-paginator";
import $ from "jquery";
import _ from "lodash";
import notificationService from "./General/NotificationService";
import TableCustomTotal from "../Shared/TableCustomTotal";
import PermissionFeature from "../Permissions/PermissionFeature";
import NotificationTable from "./Tables/NotificationTable";
class NotificationModule extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notifications: null,
    };
    this.user = AuthService.getProfile().memberData;
  }
  componentDidMount() {
    if (!AuthService.canView(PermissionFeature.NotificationModule)) {
      this.props.history.push(
        `/dashboard/myProfile/${this.user && this.user.id}`
      );
      return false;
    }
  }

  componentWillUnmount() {}
  render() {
    // New Work

    return (
      <AUX>
        {AuthService.canView(PermissionFeature.NotificationModule) && (
          <div className="container-fluid">
            <div class="page-title-box">
              <div className="row align-items-center">
                <div class="col-lg-12">
                  <h4 class="text-uppercase page-title-search">
                    Notifications
                  </h4>
                  <p>
                    This section is used to configure email notifications
                    triggered by various system events.
                  </p>
                </div>
                <NotificationTable />
              </div>
            </div>
          </div>
        )}
      </AUX>
    );
  }
}

export default NotificationModule;
